import { createSelector } from '@ngrx/store';
import { getHistoryOrderByOrderGUID } from '../getHistoryOrderByOrderGUID';

export const isHistoryOrderIsFinalized = (orderGUID: string) =>
    createSelector(getHistoryOrderByOrderGUID(orderGUID), (order) => {
        if (!order?.data) return false;

        return order.data.Status === OLO.Enums.ONLINE_ORDER_STATUS.FINALIZED;
    });
